import { Injectable } from "@angular/core";
import { MatSnackBar as MatSnackBar } from "@angular/material/snack-bar";

@Injectable({ providedIn: "root" })
export class ToastService {
  constructor(private _snackBar: MatSnackBar) {}

  public openToast(toastMessage: string) {
    this._snackBar.open(toastMessage, "Dismiss", {
      duration: 5000,
      panelClass: "snackbar-success",
    });
  }

  public openErrorToast(toastMessage: string) {
    this._snackBar.open(toastMessage, "Dismiss", {
      duration: 5000,
      panelClass: "snackbar-error",
    });
  }
}
